export const oneDriveType = 'onedrive';
